import classNames from "classnames";
import { flattenChildren, getReactNodeKey } from "client/Misc/reactUtils";
import {
	PropsWithChildren,
	ReactElement,
	ReactNode,
	useMemo,
	isValidElement
} from "react";
import {
	ControlAttachmentContext,
	ControlAttachmentContextData,
	ControlAttachmentKind
} from "../ControlAttachment";
import styles from "./InputRow.module.less";

export const InputRow = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	const childrenArray = useMemo(
		(): ReactNode[] => {
			return flattenChildren(children);
		},
		[children]
	);

	return (
		<div className={styles.root}>
			{childrenArray.map(
				(x, i) => (
					<ItemWrapper
						key={getReactNodeKey(x, i)}
						index={i}
						total={childrenArray.length}
						width={isValidElement(x) && x.type === InputRowStretch ? "stretch" : "auto"}
					>
						{x}
					</ItemWrapper>
				)
			)}
		</div>
	);
};
InputRow.displayName = "InputRow";

export const InputRowStretch = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return <>{children}</>;
};
InputRowStretch.displayName = "InputRowStretch";
InputRow.Stretch = InputRowStretch;

type ItemWrapperProps = {
	index: number;
	total: number;
	width: "auto" | "stretch";
};

const ItemWrapper = (props: PropsWithChildren<ItemWrapperProps>): ReactElement => {
	const {
		index,
		total,
		width,
		children
	} = props;

	const attachmentContextData = useMemo(
		(): ControlAttachmentContextData => {
			const result: ControlAttachmentKind[] = [];
			if (index > 0) {
				result.push("left");
			}

			if (index < total - 1) {
				result.push("right");
			}

			return { attachedOn: result };
		},
		[index, total]
	);

	return (
		<div
			className={classNames(
				styles.item,
				{ [styles.item_stretched]: width === "stretch" }
			)}
		>
			<ControlAttachmentContext.Provider value={attachmentContextData}>
				{children}
			</ControlAttachmentContext.Provider>
		</div>
	);
};
ItemWrapper.displayName = "ItemWrapper";